import React from 'react';
import { Route } from 'react-router-dom';
import { PageIndex } from '../page';
export const WarpRoute = ({ side, component: Component, ...rest }) =>
  side ? (
    <Route
      {...rest}
      render={(routeProps) => (
        <PageIndex {...routeProps}>
          <Component {...routeProps} />
        </PageIndex>
      )}
    />
  ) : (
    <Route {...rest} component={Component} />
  );
